module.exports = __webpack_public_path__ + "img/10-6.2a44f400.png";